const apis = {
    GetCity: 'MasterSetup/GetCity',
    GetZone: 'MasterSetup/GetZone',
    GetRegion: 'MasterSetup/GetRegion',
    GetVisitPurpose: 'MasterSetup/GetVisitPurpose',
    GetAccountType: 'MasterSetup/GetAccountType',
    Save: 'VisitDetails/Save',
    GetSalesAccountManagers: "MasterSetup/GetSalesAccountManagers",
    GetAccounts: "MasterSetup/GetAccounts",
    GetList: "VisitDetails/List",
    Get: "VisitDetails/Get",
    GetProjectStages: "MasterSetup/GetProjectStages",
    GetProjectList: "ProjectDetails/List",
    SaveProject: 'ProjectDetails/Save',
    GetProject: "ProjectDetails/Get",
    GetProjectDealers:"MasterSetup/GetProjectDealers",
    GetItems:"MasterSetup/GetItems",
    GetUserType:"MasterSetup/GetUserType",
    GetUserGroup:"MasterSetup/GetUserGroup",
    GetUsers:"UserManagement/GetUsers",
    SaveUser:"UserManagement/SaveUser",
    SaveStatus:"ProjectDetails/SaveStatus",
    GetProjectStatus:"ProjectDetails/GetProjectStatus",
    SaveRolesPermission:"Auth/SaveRolesPermission",
    GetRolesPermission:"Auth/GetRolesPermission",
    GetRolesPermissionList:"Auth/GetRolesPermissionList",
    RequestPasswordReset: "Auth/RequestPasswordReset",
    PasswordResetList: "Auth/PasswordResetList",
    ResolvePasswordReset: "Auth/ResolvePasswordReset",
    DeleteProjectAttachment: "ProjectDetails/DeleteAttachment",

};

export default apis;
